import service from '../service/coupon'
import CONSTANT from '../constant/coupon'
import _ from 'underscore'
import { Indicator } from 'mint-ui';
export default {
    bindingCoupon ({commit}, data) {
        Indicator.open();
        return new Promise((resolve, reject) => {
            return service.bindingCoupon(data).then(result => {
                resolve(result)
                commit(CONSTANT.COUPON_BINDINGCOUPON_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.COUPON_BINDINGCOUPON_ERROR, e)
                commit('rootApperError', e)
                Indicator.close();
            })
        })
    },
    getCouponList ({commit}, data) {
        Indicator.open();
        return new Promise((resolve, reject) => {
            return service.getCouponList(data).then(result => {
                resolve(result)
                commit(CONSTANT.COUPON_GETCOUPONLIST_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.COUPON_GETCOUPONLIST_ERROR, e)
                // commit('rootApperError', e)
                Indicator.close();
            })
        })
    },
    getCouponCount ({commit}, data) {
        return new Promise((resolve, reject) => {
            return service.getCouponCount(data).then(result => {
                resolve(result)
                commit(CONSTANT.COUPON_GETCOUPONCOUNT_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.COUPON_GETCOUPONCOUNT_ERROR, e)
                // commit('rootApperError', e)
            })
        })
    },
    /*yeoman-template-point-1*/
}